<template>
  <div>
    <!-- CHANGE PASSWORD -->
    <v-dialog max-width="500" v-model="changePasswordModal" persistent>
      <UpdatePassword
        :onCancel="onPasswordChange"
        :onSuccess="onPasswordChange"
        :userId="$store.state.Id"
      />
    </v-dialog>

    <!-- LOGOUT -->
    <v-dialog v-model="dialogLogout" persistent max-width="320">
      <v-card class="dialog-card">
        <v-card-title class="headline">
          <span class="logout-title mb-2">{{ $t("title.logout") }}</span>
        </v-card-title>

        <v-card-text class="mt-4 pb-0">
          {{ $t("description.logout") }}
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="red darken-1" text @click="signOut">
            {{ $t("buttons.yes") }}
          </v-btn>
          <v-btn text @click="dialogLogout = false">
            {{ $t("buttons.no") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- PROFILE -->
    <v-dialog v-model="profileDialog" persistent max-width="520">
      <v-card class="profile-card">
        <v-card-title class="headline">
          {{ $t("title.ProfileInfo") }}
        </v-card-title>

        <v-card-text>

          <!-- AVATAR (fallback initials) -->
          <v-row justify="center" class="mb-5">
            <v-avatar size="84" class="profile-avatar" color="var(--primary-color)">
              <v-img
                v-if="$store.state?.Avatar"
                :src="$store.state.Avatar"
              />
              <span v-else class="avatar-text">
                {{ getInitials(name) }}
              </span>
            </v-avatar>
          </v-row>

          <!-- NAME -->
          <div class="profile-item">
            <div class="label">Ad Soyad</div>
            <div class="value">{{ name }}</div>
          </div>

          <!-- USERNAME -->
          <div class="profile-item">
            <div class="label">{{ $t("labels.userName") }}</div>
            <div class="value">{{ $store.state.Username }}</div>
          </div>

          <!-- ROLE -->
          <div class="profile-item">
            <div class="label">Rol</div>
            <div class="value role">{{ userType }}</div>
          </div>

        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="profileDialog = false">
            {{ $t("buttons.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- APP BAR -->
    <v-app-bar app flat elevation="0" class="app-bar">
      <v-spacer />

      <v-toolbar-title>
        <v-img
          height="42"
          contain
          :src="require('@/../public/img/logo.png')"
        />
      </v-toolbar-title>

      <v-spacer />

      <!-- USER MENU -->
      <v-menu offset-y transition="scale-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-avatar
            v-bind="attrs"
            v-on="on"
            size="38"
            color="var(--primary-color)"
            class="avatar-btn"
          >
            <span class="avatar-text">
              {{ getInitials(name) }}
            </span>
          </v-avatar>
        </template>

        <v-list dense class="menu-list">
          <v-list-item class="menu-item" @click="openProfile">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ name }}</v-list-item-title>
          </v-list-item>

          <v-list-item class="menu-item">
            <v-list-item-icon>
              <v-icon>mdi-shield-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ userType }}</v-list-item-title>
          </v-list-item>

          <v-list-item class="menu-item" @click="changePasswordModal = true">
            <v-list-item-icon>
              <v-icon color="warning">mdi-key</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ $t("labels.changePassword") }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item class="menu-item logout" @click="dialogLogout = true">
            <v-list-item-icon>
              <v-icon color="red darken-1">mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ $t("buttons.logout") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import store from "../store/store";
import AdminService from "../services/AdminService";
import UpdatePassword from "./UpdatePassword.vue";
import { mapActions } from "vuex";

export default {
  name: "NavMenu",
  components: { UpdatePassword },

  data() {
    return {
      dialogLogout: false,
      profileDialog: false,
      changePasswordModal: false,

      name: store.getters.getUserFullName,   // Ahmet SAYGIN
      userType: store.getters.getUserType,   // Admin
      Id: store.getters.getId,

      url: ""
    };
  },

  mounted() {
    this.getProfileInfo();
  },

  methods: {
    openProfile() {
      this.profileDialog = true;
    },

    onPasswordChange() {
      this.changePasswordModal = false;
    },

    signOut() {
      this.dialogLogout = false;
      this.logout();
    },

    getProfileInfo() {
      return;
      AdminService.getDetails(this.Id)
        .then((res) => {
          if (!res.data.Data.length) {
            window.showInfo("Kullanıcı bulunamadı", "standart", "error");
            this.logout();
          }
        })
        .catch((err) => {
          window.showError(err);
        });
    },

    getInitials(fullName) {
      if (!fullName) return "U";
      return fullName
        .split(" ")
        .map(n => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
    },

    ...mapActions(["logout"])
  }
};
</script>

<style scoped>
.logout-title{
  color: white !important;
}

.v-list-item--dense .v-list-item__icon, .v-list--dense .v-list-item .v-list-item__icon{
  margin-right: 12px;
}
/* APP BAR */
.app-bar {
  background: rgba(255,255,255,0.75) !important;
  backdrop-filter: blur(12px);
  border-bottom: 1px solid #eef2f6;
}

/* AVATAR */
.avatar-btn {
  cursor: pointer;
  transition: all 0.25s ease;
  font-weight: 600;
}

.avatar-btn:hover {
  transform: translateY(-1px) scale(1.05);
}

.avatar-text {
  color: white;
  font-size: 13px;
  font-weight: 600;
}

/* MENU */
.menu-list {
  border-radius: 12px;
  padding: 6px;
}

.menu-item {
  border-radius: 10px;
  margin: 4px 0;
  transition: 0.2s;
}

.menu-item:hover {
  background: #f6f8fb;
  transform: translateX(2px);
}

.logout:hover {
  background: #fff1f1;
}

/* PROFILE */
.profile-card {
  border-radius: 14px;
}

.profile-avatar {
  box-shadow: 0 6px 18px rgba(0,0,0,0.15);
}

.profile-item {
  margin-bottom: 14px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f8fafc;
}

.label {
  font-size: 12px;
  color: #94a3b8;
}

.value {
  font-size: 15px;
  font-weight: 500;
  color: #1f2937;
}

.role {
  color: #1976d2;
  font-weight: 600;
}
</style>